import React, { useState, ChangeEvent, useRef, useEffect } from 'react'
import { FormikProps, withFormik, Form } from 'formik'
import Input from '../../input'
import { useTranslation } from 'react-i18next'
import { useWindowSize } from '../../../helpers/hooks/hookWindowsSize'
import Select from '../../select'
import { ALTERA_DOMAIN } from '../../../helpers/config/config'
import QRCode from 'qrcode.react'
import { ChromePicker } from 'react-color'
import { linkPrimary } from '../../../images'
import { toast } from 'react-toastify'
import { t } from 'i18next'

type qrValues = {
  color: string
  logo: string
}

interface CreateNewFormProps {
  url: string
  domain: string
  title: string
  custom_code: string
  has_qr: boolean
  qr_code: qrValues
  onSubmit: (values: CreateNewFormValues) => void
  children?: React.ReactNode
  shortUrlGenerated: string
  domains: string[]
  canCreateQR: boolean
  userInfo: any
}

interface CreateNewFormValues {
  url: string
  domain: string
  title: string
  custom_code: string
  has_qr: boolean
  qr_code: qrValues
}

const InnerForm: React.FunctionComponent<
  CreateNewFormProps & FormikProps<CreateNewFormValues>
> = ({
  values,
  handleChange,
  touched,
  shortUrlGenerated,
  domains,
  canCreateQR,
  userInfo,
}) => {
  const { t } = useTranslation()
  const sizeWidth = useWindowSize().width
  const [url, setUrl] = useState('')
  const [color, setColor] = useState('#000000')
  const [showPaletteColor, setShowPaletteColor] = useState(false)
  const [previewUrl, setPreviewUrl] = useState<string | null>(null)
  const fileInputRef = useRef<HTMLInputElement | null>(null)
  const [customDomain, setCustomDomain] = useState(false)

  const domainData = domains?.map((item) => {
    return { value: item, label: item }
  })

  useEffect(() => {
    values.qr_code.color = color
  }, [color])

  useEffect(() => {
    if (values.domain === domainData[0].value) {
      setCustomDomain(false)
    } else if (
      userInfo.permissions.custom_domain &&
      userInfo.permissions.custom_post_domain &&
      values.domain !== domainData[0].value
    ) {
      setCustomDomain(true)
    }
  }, [values.domain])

  const handleColorChange = (selectedColor: {
    hex: React.SetStateAction<string>
  }) => {
    setColor(selectedColor.hex)
  }

  const handleQRCodeClick = () => {
    setShowPaletteColor(!showPaletteColor)
  }

  const handleChangeUrl = (e: ChangeEvent<HTMLInputElement>) => {
    handleChange(e)
    setUrl(e.target.value)
  }

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    // if (e.target.files && e.target.files.length > 0) {
    //   const file = e.target.files[0]
    //   const imageUrl = URL.createObjectURL(file)
    //   setPreviewUrl(imageUrl)
    //   values.qrLogo = file
    // }
  }

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click()
    }
  }

  return (
    <>
      <Form>
        <div className='container-form-qr'>
          <div className='container-urls'>
            <div className='container-create-url'>
              <Input
                id='url'
                label={`${t('DESTINATION')}`}
                classNameLabel='color-primary'
                type='text'
                value={values.url}
                onChange={handleChangeUrl}
                touched={touched.url}
                classNameInput='input'
                required
                placeholder={`${t('MY_LONG_URL')}`}
                className='col-12'
              />
              <Input
                id='title'
                label={`${t('TITLE')} (${t('OPTIONAL')})`}
                type='text'
                value={values.title}
                onChange={handleChange}
                touched={touched.title}
                classNameInput='input'
                placeholder={`${t('TITLE')}`}
                className='col-12 col-md-6'
                classNameLabel='color-grey-dark'
              />
            </div>
          </div>
        </div>
        <div className='container-view-qr'>
          <div className='column-qr'>
            <>
              <div className='d-grid'>
                <span>{`${t('PREVIEW')}`}</span>
                <span className='small'>{`${t('PREVIEW_QR_CODE')}`}</span>
              </div>

              <div className='container-qr-code-center'>
                <div className='container-qr-code'>
                  <QRCode
                    value={shortUrlGenerated || ALTERA_DOMAIN}
                    fgColor={color}
                    size={100}
                    bgColor='transparent'
                    level='H'
                    imageSettings={{
                      src: !previewUrl ? '' : previewUrl,
                      height: 35,
                      width: 35,
                      excavate: true,
                    }}
                  />
                </div>
              </div>
              {/*esto es ocultar la subida del logo mientras siempre*/}
              {/* <span className='small'>{`${t('QR_CODE_CHARACTERISTICS')}`}</span> */}
            </>
            {/* <div className='d-grid'>
              <button
                type='button'
                className='button-sixth my-4'
                onClick={handleButtonClick}
              >{`${t('UPLOAD_YOUR_LOGO')}`}</button>

              <input
                type='file'
                accept='image/*'
                ref={fileInputRef}
                className='input-file'
                onChange={handleFileChange}
                id='qrLogo'
                name='qrLogo'
              />
              <span className='small'>{`${t('QR_CODE_LOGO_INFO')}`}</span>
            </div> */}
          </div>
          <div className='container-column-qr-palette'>
            <div className='column-qr-palette'>
              <div className='d-flex position-relative'>
                <button
                  type='button'
                  className='button-select-color'
                  style={{ backgroundColor: color }}
                  onClick={handleQRCodeClick}
                ></button>
                <Input
                  id='color'
                  label={`${t('QR_CODE_COLOR')}`}
                  classNameLabel='color-black'
                  type='text'
                  value={values.qr_code.color}
                  onChange={handleChange}
                  touched={touched.qr_code?.color}
                  classNameInput='input'
                  className='col-12 col-md-6'
                  customClass='input-select-qr-code'
                />
              </div>

              {showPaletteColor && (
                <ChromePicker
                  color={color}
                  onChange={handleColorChange}
                  className='position-absolute'
                />
              )}
              <span className='small'>{`${t('QR_WARNING_CREATION')}`}</span>
            </div>
          </div>
        </div>

        <div className='container-view-url'>
          <div>
            <img
              src={linkPrimary}
              alt={`${t('URL_SHORT')}`}
              width={20}
              height={20}
              className='margin-right-1'
            />
            <span className='sub-title-primary'>{`${t('URL_SHORT')}`}</span>
          </div>

          <div className='container-urls'>
            <div className='container-create-url-domain'>
              <Select
                disabled={!userInfo.permissions.custom_domain}
                optionSelect={false}
                options={domainData}
                id='domain'
                label={`${t('DOMAIN')}`}
                value={values.domain}
                classNameSelect='customized-select-form'
                onChange={handleChange}
                className='col-12'
              />
              {sizeWidth > 767 && (
                <div className='container-link-separator'>
                  <span className='link-separator'>/</span>
                </div>
              )}

              <Input
                disabled={!customDomain}
                id='custom_code'
                label={`${t('MY_CUSTOM_URL')} (${t('OPTIONAL')})`}
                classNameLabel='color-grey-dark'
                type='text'
                value={values.custom_code}
                onChange={handleChange}
                touched={touched.custom_code}
                classNameInput='input'
                placeholder={`${t('MY_CUSTOM_URL')}`}
                className='col-12 col-md-6'
              />
            </div>
          </div>
        </div>

        <div className='container-butttons-general-right'>
          <button className='button-third margin-right-2' type='button'>
            {`${t('CANCEL')}`}
          </button>
          <button
            className={`${
              canCreateQR ? 'button-first' : 'button-fourth button-disabled'
            }`}
            type='submit'
            disabled={!canCreateQR}
          >
            {`${t('CREATE')}`}
          </button>
        </div>
      </Form>
    </>
  )
}

const CreateNewForm = withFormik<CreateNewFormProps, CreateNewFormValues>({
  mapPropsToValues: (props: any) => {
    const { url, domain, qr_code } = props

    const initialValues = {
      url,
      domain,
      title: '',
      custom_code: '',
      has_qr: true,
      qr_code: {
        color: qr_code.color || '',
        logo: qr_code.logo || '',
      },
    }

    return initialValues
  },

  handleSubmit(values: CreateNewFormValues, { props }: any) {
    const hexRegex = /^#([A-Fa-f0-9]{3}){1,2}$/
    if (hexRegex.test(values.qr_code.color)) {
      props.onSubmit(values)
    } else {
      toast(`${t('ERROR_HEXADECIMAL_COLOR')}`)
    }
  },
})(InnerForm)
export default CreateNewForm
